<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title_four')" />

        <InLaysBenefits/>
    </div>
</template>

<script>
import InLaysBenefits from '../blog-details/InLaysBenefits.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        InLaysBenefits ,
    }
}
</script>